import { useState } from "react";
import useSeo from "../../hooks/useSeo";

const DAYS = [
  { day: "第一天", q: "你觉得这个人怎么样？" },
  { day: "第二天", q: "第一次一起吃饭，感觉如何？" },
  { day: "第三天", q: "第一次发生分歧，你怎么处理？" },
  { day: "第四天", q: "一起花钱时，你在意什么？" },
  { day: "第五天", q: "一起规划未来，你更想先做什么？" },
  { day: "第六天", q: "如果现在回家，还会想念对方吗？" },
  { day: "第七天", q: "现在是否愿意结婚？" },
];

export default function ImpulseSimulator() {
  const [step, setStep] = useState(0);
  const [answers, setAnswers] = useState([]);
  const [done, setDone] = useState(false);

  useSeo({
    title: "旅行回来，我们还是夫妻吗？",
    metaDescription: "七天情侣旅行婚姻体验，纯娱乐，不作为实际婚姻决策依据。",
    path: "/travel/impulse",
  });

  const choose = (text) => {
    const next = [...answers, text];
    setAnswers(next);
    if (step >= DAYS.length - 1) setDone(true);
    else setStep(step + 1);
  };

  const scores = {
    浪漫指数: 70 + (answers[0]?.length || 0) % 20,
    沟通指数: answers[2]?.includes("听") || answers[2]?.includes("冷静") ? 86 : 72,
    消费观: answers[3]?.includes("预算") ? 80 : 71,
    生活习惯: 85,
    婚姻协作: answers[6]?.includes("愿意") ? 88 : 64,
  };

  return (
    <div className="max-w-xl mx-auto space-y-6">
      <h1 className="text-3xl font-extrabold">😂 旅行回来，我们还是夫妻吗？</h1>
      <p className="text-xs text-amber-800 bg-amber-50 rounded-xl p-3">该功能纯娱乐，不作为实际婚姻决策依据。</p>
      {!done ? (
        <div className="bg-white rounded-2xl p-6 space-y-4">
          <p className="text-sm text-gray-400">{DAYS[step].day}</p>
          <p className="text-xl font-bold">{DAYS[step].q}</p>
          <div className="grid gap-2">
            {["挺喜欢的", "还需要观察", "有点不确定", "愿意认真谈谈 / 愿意"].map((opt) => (
              <button key={opt} className="border rounded-xl py-2 hover:bg-rose-50" onClick={() => choose(opt)}>
                {opt}
              </button>
            ))}
          </div>
        </div>
      ) : (
        <div className="bg-white rounded-2xl p-6 space-y-3">
          <h2 className="font-bold text-xl">《7天情侣旅行婚姻体验报告》</h2>
          {Object.entries(scores).map(([k, v]) => (
            <p key={k}>
              {k}：{v}
            </p>
          ))}
          <p className="text-rose-600 font-medium">
            {scores.婚姻协作 >= 80 ? "建议先继续旅行，把喜欢变成可执行的约定。" : "建议回家睡一觉再决定。"}
          </p>
        </div>
      )}
    </div>
  );
}
